// extracted by mini-css-extract-plugin
export default {"featureBannerContent":"FeatureBanner_featureBannerContent__JB4r+"};